<template>
  <div>
    <el-input placeholder="请输入正确的采购合同编号" v-model="form.chaxun" class="input-with-select">
      <el-button slot="append" icon="el-icon-search" @click="GetForm()">查询</el-button>
    </el-input>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="日期">
        <template slot-scope="scope">
          <el-input v-model="scope.row.createTime" :disabled="kexing" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label="合同编号">
        <template slot-scope="scope">
          <el-input v-model="scope.row.contractNo" :disabled="kexing" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label="采购数量">
        <template slot-scope="scope">
          <el-input v-model="scope.row.amount" :disabled="kexing" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label="采购单价">
        <template slot-scope="scope">
          <el-input v-model="scope.row.unitPrice" :disabled="kexing" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label="采购总价">
        <template slot-scope="scope">
          <el-input v-model="scope.row.totalPrice" :disabled="kexing" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <el-input v-model="scope.row.remark" :disabled="kexing" clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350px">
        <template slot-scope="scope">
          <el-button size="mini" @click="hetong(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="hetongDelete(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" @click="tianjiasuo()" v-if="tianjia" type="primary">添加锁</el-button>
          <el-button size="mini" @click="shangchuanhetong()" v-if="shangchuan" type="success">确认修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加功能 -->
    <el-form ref="input" :model="input" label-width="80px" v-if="jiamisuo">
      <el-form-item></el-form-item>
      <el-form-item label="外部锁号">
        <el-input v-model="input.encryptNo" autocomplete="on"></el-input>
      </el-form-item>
      <el-form-item label="内部锁号">
        <el-input v-model="input.innerEncryptNo"></el-input>
      </el-form-item>
    </el-form>
    <!-- 添加的加密锁信息表 -->
    <div v-if="jiamisuoxinxi">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="外部锁号" prop="encryptNo">
          <template slot-scope="scope">
            <el-input v-model="scope.row.encryptNo" :disabled="kexing1" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column label="内部锁号" prop="innerEncryptNo">
          <template slot-scope="scope">
            <el-input v-model="scope.row.innerEncryptNo" :disabled="kexing1" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="suobianji(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="shangchuansuo()" v-if="baocun" type="success">单条上传</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <div class="box">
          <input
            type="file"
            name="file-1[]"
            id="file-1"
            @input="inputfunc"
            class="inputfile inputfile-1"
            data-multiple-caption="{count} files selected"
            multiple
          />
          <label for="file-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
              <path
                d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
              />
            </svg>
            <span>批量上传&hellip;</span>
          </label>
        </div>
        <el-button type="success" @click="Batchsubmit()">批量提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tianjia: false,
      shangchuan: false,
      kexing: true,
      kexing1: true,
      baocun: false,
      jiamisuo: false,
      jiamisuoxinxi: false,
      input: {
        encryptNo: "",
        innerEncryptNo: "",
      },
      form: {
        chaxun: "",
      },
      tableData: [],
    };
  },
  methods: {
    tianjiasuo() {
      this.input = {};
      this.jiamisuoxinxi = true;
    },
    Batchsubmit() {
      var fileInput = document.getElementById("file-1");
      let formData = new FormData();
      formData.append("contractId", this.tableData[0].id);
      formData.append("lockFile", fileInput.files[0], fileInput.files[0].name);
      this.$http
        .post(this.$getaxiosurl("/enc/purchase/batchPurchaseLock"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "提交成功",
              type: "success",
            });
          } else {
            return this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    inputfunc() {
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();
          if (fileName) label.querySelector("span").innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },
    GetForm() {
      if (this.form.chaxun.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请输入采购合同编号",
          type: "error",
        });
      }
      let formData = new FormData();
      formData.append("contractNo", this.form.chaxun);
      this.$http
        .post(
          this.$getaxiosurl("/enc/purchase/queryPurchaseContract"),
          formData
        )
        .then((response) => {
          if (response.data.contract !== null) {
            this.tableData = [];
            this.jiamisuoxinxi = false;
            this.kexing = true;
            this.tianjia = false;
            this.shangchuan = false;
            this.kexing1 = true;
            this.baocun = false;
            this.tableData.push(response.data.contract);
            if (response.data.code == "00100") {
              this.$message({
                message: "查询成功",
                type: "success",
                duration: 8000,
              });
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    hetong() {
      this.kexing = false;
      this.tianjia = true;
      this.shangchuan = true;
    },
    suobianji() {
      this.kexing1 = false;
      this.baocun = true;
    },
    shangchuanhetong() {
      this.kexing = true;
      if (this.tableData[0].contractNo == "") {
        return this.$message({
          message: "合同编号不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (this.tableData[0].amount == "") {
        return this.$message({
          message: "采购数量不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (this.tableData[0].unitPrice == "") {
        return this.$message({
          message: "采购单价不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (this.tableData[0].totalPrice == "") {
        return this.$message({
          message: "采购总价不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (this.tableData[0].createTime == "") {
        return this.$message({
          message: "日期不能为空",
          type: "error",
          duration: 8000,
        });
      }
      let formData = new FormData();
      formData.append("id", this.tableData[0].id);
      formData.append("contractNo", this.tableData[0].contractNo);
      formData.append("amount", this.tableData[0].amount);
      formData.append("unitPrice", this.tableData[0].unitPrice);
      formData.append("totalPrice", this.tableData[0].totalPrice);
      formData.append("purchaseDate", this.tableData[0].createTime);
      formData.append("remark", this.tableData[0].remark);
      this.$http
        .post(this.$getaxiosurl("/enc/purchase/editPurchaseContract"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 8000,
            });
            this.tableData = [];
          } else {
            this.$message({
              message: "没有相关合同信息",
              type: "error",
            });
          }
        });
    },
    shangchuansuo() {
      this.kexing1 = true;
      if (
        this.tableData[0].encryptNo == undefined ||
        this.tableData[0].innerEncryptNo == undefined
      ) {
        return this.$message({
          message: "锁号不能为空",
          type: "success",
          duration: 8000,
        });
      }
      let formData = new FormData();
      formData.append("contractId", this.tableData[0].id);
      formData.append("encryptNo", this.tableData[0].encryptNo);
      formData.append("innerEncryptNo", this.tableData[0].innerEncryptNo);
      this.$http
        .post(this.$getaxiosurl("/enc/purchase/createPurchaseLock"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "上传成功",
              type: "success",
              duration: 8000,
            });
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    hetongDelete(index) {
      this.tableData.splice(index, 1);
      this.jiamisuoxinxi = false;
    },
  },
};
</script>
<style scoped>
.box {
  margin-top: 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.js .inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  max-width: 80%;
  font-size: 1.25rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.no-js .inputfile + label {
  display: none;
}
.inputfile:focus + label,
.inputfile.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}
.inputfile-1 + label {
  color: #f1e5e6;
  background-color: #409eff;
}
.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
  background-color: #67c23a;
}
</style>
